import { motion } from 'framer-motion';
import { Coins, AlertTriangle } from 'lucide-react';

export function CreditStatus({ credits, onBuyCredits }) {
  const isLowCredits = credits <= 2;
  const noCredits = credits <= 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-lg p-4 ${
        noCredits
          ? 'bg-red-50 border-2 border-red-200'
          : isLowCredits
            ? 'bg-amber-50 border-2 border-amber-200'
            : 'bg-emerald-50'
      }`}
    >
      <div className="flex items-start gap-3">
        {noCredits ? (
          <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        ) : (
          <Coins
            className={`w-5 h-5 ${
              isLowCredits ? 'text-amber-500' : 'text-emerald-500'
            } flex-shrink-0 mt-0.5`}
          />
        )}

        <div className="flex-1">
          <div className="flex items-baseline gap-2">
            <h3
              className={`font-medium ${
                noCredits
                  ? 'text-red-800'
                  : isLowCredits
                    ? 'text-amber-800'
                    : 'text-emerald-800'
              }`}
            >
              {credits} {credits === 1 ? 'Credit' : 'Credits'} Remaining
            </h3>
          </div>

          {noCredits && (
            <p className="text-sm text-red-600 mt-1">
              Your credits are exhausted. Purchase more credits to continue
              identifying plants.
            </p>
          )}

          {isLowCredits && !noCredits && (
            <p className="text-sm text-amber-600 mt-1">
              Running low on credits. Consider purchasing more to continue using
              the service.
            </p>
          )}
        </div>

        <button
          onClick={onBuyCredits}
          className={`flex-shrink-0 px-4 py-2 rounded-lg font-medium text-sm ${
            noCredits
              ? 'bg-red-600 text-white hover:bg-red-700'
              : isLowCredits
                ? 'bg-amber-600 text-white hover:bg-amber-700'
                : 'bg-emerald-600 text-white hover:bg-emerald-700'
          } transition-colors`}
        >
          Buy Credits
        </button>
      </div>
    </motion.div>
  );
}
